import { CHECKOUT_UI } from '../constants/orders'
import {
  PAYMENT_GATEWAY,
  type PaymentCheckoutSession,
  type PaymentGatewayId,
  type RazorpayCheckoutPayload,
} from '../constants/payments'
import type { ApiCheckout } from '../api/types'

export function isPaymentGateway(value: unknown): value is PaymentGatewayId {
  return value === PAYMENT_GATEWAY.razorpay || value === PAYMENT_GATEWAY.cashfree
}

export function isRazorpayCheckoutPayload(value: unknown): value is RazorpayCheckoutPayload {
  if (!value || typeof value !== 'object') return false
  const row = value as Record<string, unknown>
  return typeof row.keyId === 'string' && typeof row.orderId === 'string'
}

export function readPaymentSession(value: unknown): PaymentCheckoutSession {
  if (!value || typeof value !== 'object') {
    throw new Error(CHECKOUT_UI.paymentMissing)
  }
  const row = value as Record<string, unknown>
  if (isPaymentGateway(row.gateway)) {
    return {
      gateway: row.gateway,
      razorpay: isRazorpayCheckoutPayload(row.razorpay) ? row.razorpay : null,
    }
  }
  if (isRazorpayCheckoutPayload(value)) {
    return { gateway: PAYMENT_GATEWAY.razorpay, razorpay: value }
  }
  throw new Error(CHECKOUT_UI.paymentMissing)
}

export function sessionFromCheckout(checkout: ApiCheckout): PaymentCheckoutSession | null {
  if (checkout.payment) {
    return {
      gateway: checkout.payment.gateway,
      razorpay: checkout.payment.razorpay ?? checkout.razorpay ?? null,
    }
  }
  if (checkout.razorpay) {
    return { gateway: PAYMENT_GATEWAY.razorpay, razorpay: checkout.razorpay }
  }
  return null
}
